import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Team } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0180. チーム一覧
 * [GET] /workspaces/:identifier/teams
 */
type Props = {
  identifier: string;
  sales_order_menu_listed?: boolean;
  purchase_order_menu_listed?: boolean;
};
const teams = (props: Props): Promise<Team[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams`, { params: props });
};

export const useTeams = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams'],
    queryFn: () => teams(props),
  });
};

export const useTeamsSalesOrderMenuListed = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', 'sales_order_menu_listed'],
    queryFn: () => teams({ ...props, sales_order_menu_listed: true }),
  });
};

export const useTeamsPurchaseOrderMenuListed = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', 'purchase_order_menu_listed'],
    queryFn: () => teams({ ...props, purchase_order_menu_listed: true }),
  });
};

export const useInvalidateTeams = (identifier: string) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'teams'] });
  };

  return { invalidate };
};
